import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { withRouter } from "react-router-dom";
import tourSteps from "./steps.js";
import { connect } from 'react-redux';
import React, { PureComponent } from "react";
import Tooltip from "./Tooltip"

const tourDesign = {
  arrowColor: '#2d9aa6',
  beaconSize: 0,
  primaryColor: '#37414F',
  overlayColor: 'rgba(0, 0, 0, 0.5)',
  spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
  zIndex: 99,
};

class Tour extends PureComponent {

  constructor (props) {
    super(props)
    this._isMounted = false;
    this.state={
      key: new Date(), // This field makes the tour to re-render when we restart the tour
      run: false,
      continuous: true, // Show next button
      loading: false,
      stepIndex: 0, // Make the component controlled
      steps: tourSteps
    }
    // Bind event handlers and methods
    this.tourCallback = this._tourCallback.bind(this)
  }

  _tourCallback(data){
    const { action, index, type, status } = data;
    if (
      // If skipped or end tour, then close the tour
      (status === STATUS.SKIPPED && this.state.run) ||
      status === STATUS.FINISHED
    ) {
      this.setState({run:false});
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      this.setState({stepIndex:index + (action === ACTIONS.NEXT ? 1 : 0)});
      // Check if next button was clicked and update the step
    }
  };

  render() {
    return (
      <div>
      <JoyRide
        {...this.state}
        tooltipComponent={Tooltip}
        steps={tourSteps}
        continuous={true}
        hideCloseButton={true}
        hideBackButton={true}
        showSkipButton={true}
        disableOverlayClose={true}
        styles={{options: tourDesign}}
        run={true}
        callback={this.tourCallback}
      />
    </div>
    )
  }

}

function mapStateToProps(state) {
  return {
      user: state.auth.user,
      settings: state.auth.settings,
      toggleTour: state.toggleTour
  }
}

export default connect((mapStateToProps))(withRouter(Tour))


// WEBPACK FOOTER //
// ./src/components/tour/e-commerce/Tour.js